import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AppLayout from "@/components/AppLayout";
import HomePage from "@/pages/HomePage";
import PageViewer from "@/pages/PageViewer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SiteGate from "@/components/SiteGate";

function App() {
    return (
        <div className="App">
            <SiteGate>
                <BrowserRouter>
                    <Routes>
                        <Route element={<AppLayout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/p/:id" element={<PageViewer />} />
                        </Route>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </SiteGate>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    classNames: {
                        toast: "font-sans",
                    },
                }}
            />
        </div>
    );
}

export default App;
